import type { FaireProductEntity } from "../../entity_types/product";

export const p_7yuxztca83: FaireProductEntity = {
  token: "p_7yuxztca83",
  type: "product",
  name: "Coastal Home Sweet Beach House Kitchen Towel",
  brandName: "C&F Home",
  imageUrl:
    "https://cdn.faire.com/fastly/e47539175c12229acae4331f37e0df8e2f0d9a9ca0312ce2c5b9001fe14a62b7.jpeg",
  priceDollars: 4.1,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7deb5de001a245dc01213b3c1edc932bc845aa2218250ed2796731ea65b0c2be.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
